import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  ILineaNegocio,
  IPolizaPagoPendiente,
  IResumenPoliza,
  IpagoByIdPoliza,
} from 'src/app/shared/Entities/entities';
import { IPagosProducto } from 'src/app/shared/Entities/webPay.entities';
import {
  getArraySumByField,
} from 'src/app/shared/helpers/helper';
import { BusinessRuleRamoService } from 'src/app/shared/services/business-rule-ramo.service';
import { PersonService } from 'src/app/shared/services/person.service';
import { ProductService } from 'src/app/shared/services/product.service';
import { IColumnsDataTable } from '../../Entities/entities';
import { Event } from '../../enums/insights/event';
import { PipeEnum, tipoPrima } from '../../helpers/constants';
import { AppInsightsService } from '../../services/app-insights-service';
import { ComponentInteractionService } from '@app/shared/services/component-interaction.service';

@Component({
  selector: 'app-pagar-productos',
  templateUrl: './pagar-productos.component.html',
  styleUrls: ['./pagar-productos.component.sass'],
})
export class PagarProductosComponent implements OnInit {
  @Input() idPoliza: any;
  @Input() showTotalResumen = true;
  @Input() tabLabel: any;

  @Output() $returnDataAPagar = new EventEmitter<IpagoByIdPoliza>();
  @Output() $eventModoPago = new EventEmitter<boolean>();
  showPeriodicas = false;
  showEsporadicas = false;
  showResumen = false;
  showModeAviso = false;
  showModeResumen = true;
  dataAPagar: IPolizaPagoPendiente[] = [];
  modoPago = false;
  lineaIndividuales = {} as ILineaNegocio;
  private subscriptions: Subscription[] = [];
  data: IPagosProducto;
  checkedPays: IPolizaPagoPendiente[] = [];
  abonosPays: IPolizaPagoPendiente[] = [];
  loading = false;
  error = false;
  errorAporteCUIMin = false;
  errorAporteCUIMax = false;
  msgAporteCUI = false;
  displayedColumns: IColumnsDataTable[];
  displayedColumnsACobranza: IColumnsDataTable[];
  codigoRamo: string;
  resumen: IResumenPoliza;
  pagoSeleccionadoParent: string;
  productAPVSelect: string = 'APV SELECT';
  hasEsporadicaTDAPagar: boolean = false;

  constructor(
    private productSrv: ProductService,
    private personSrv: PersonService,
    private ruleRamoService: BusinessRuleRamoService,
    private appInsightsService: AppInsightsService,
    private componentInteractionService: ComponentInteractionService
  ) {}

  ngOnInit(): void {
    this.createDisplayedColumns();
    this.createDisplayedColumnsACobranza();
    this.setDataPagos();

    if (this.tabLabel == 'APORTES') {
      this.msgAporteCUI = false;
    }
  }

  createDisplayedColumns() {
    this.displayedColumns = [
      {
        ColumnDef: 'Checked',
        ColumnName: '',
        CheckBox: true,
      },
      {
        ColumnDef: 'Periodo',
        ColumnName: 'PERÍODO',
        // Pipe: PipeEnum.da,
      },
      {
        ColumnDef: 'Monto_UF',
        ColumnName: 'MONTO (UF)',
        Pipe: PipeEnum.UFPipe,
      },
      {
        ColumnDef: 'Monto',
        ColumnName: 'MONTO ($)',
        Pipe: PipeEnum.decimalPipe,
      },
    ] as IColumnsDataTable[];
  }

  createDisplayedColumnsACobranza() {
    this.displayedColumnsACobranza = [
      {
        ColumnDef: 'Periodo',
        ColumnName: 'Período',
      },
      {
        ColumnDef: 'Monto',
        ColumnName: 'Monto en $',
        Pipe: PipeEnum.decimalPipe,
      },
      {
        ColumnDef: 'CodigoMoneda',
        ColumnName: 'Moneda',
      },
      {
        ColumnDef: 'Monto_UF',
        ColumnName: 'MONTO en UF',
        Pipe: PipeEnum.UFPipe,
      },
      {
        ColumnDef: 'download.svg',
        ColumnName: 'Descargar',
        Icon: true,
        IconAlign: 'mat-cell-right',
        SvgIcon: true,
      },
    ] as IColumnsDataTable[];
  }

  onIconClick(item) {
    item.item.Selected = false;
  }

  checkOfContinuidad(): boolean {
    return false;
  }

  getTotalMonto() {
    if (!this.data) {
      return;
    }

    const dataCheck = this.data.PagosPendientes ? 
    this.data.PagosPendientes.filter(p => p.Checked === true) : [];

    this.checkedPays = [...dataCheck, ...this.abonosPays];
    
    this.$returnDataAPagar.emit({
      idPoliza: this.idPoliza,
      checkedPays: this.checkedPays,
    } as IpagoByIdPoliza);

    return getArraySumByField(this.checkedPays, 'Monto');
  }

  onPagar() {
    this.appInsightsService.trackEvent(Event.iidpBtnPayStepper);
    this.dataAPagar = this.checkedPays.filter(d => d.Checked);
    this.modoPago = true;
    this.$eventModoPago.emit(this.modoPago);
  }

  closeWebPay(propuestas: IPolizaPagoPendiente[] = []) {
    this.abonosPays = [];
    if (this.data.PagosPendientes) {
      this.data.PagosPendientes.forEach(pago => {
        pago.Checked = false;
      });
    }
    propuestas.forEach(element => {
      if (element.NombreProducto === 'Aporte esporádico') {
        this.abonosPays.push(element);
        return;
      }
      if (!this.data.PagosPendientes) {
        return;
      }
      const pagoPendiente = this.data.PagosPendientes.find(
        pago => pago.Periodo === element.Periodo
      );

      if (!pagoPendiente) {
        return;
      }
      pagoPendiente.Checked = true;
    });
    this.modoPago = false;
    this.$eventModoPago.emit(this.modoPago);
    this.data = this.data;

    if (this.showModeAviso) {
      this.pagoSeleccionadoParent = 'Pagar online';
    }
  }

  onRealizarAporte(aporte: IPolizaPagoPendiente[]) {
    this.appInsightsService.trackEvent(Event.btnPayProduct);

    this.errorAporteCUIMin = false;
    this.errorAporteCUIMax = false;
    let numPol = aporte[0].Poliza;
    let tipPri = aporte[0].TipoPrima;
    let mntPri = aporte[0].Monto;
    let medPag = aporte[0].MedioPago;

    //Se verifica que el aporte sea esporadico
    if (tipPri.toUpperCase().indexOf('ESPO') > -1) {
      //Revisión de aporte por poliza
      let totalAportePoliza = mntPri;

      this.abonosPays.forEach(i => {
        if (i.Poliza == numPol) {
          totalAportePoliza = totalAportePoliza + i.Monto;
        }
      });

      if (medPag == 'TD' && totalAportePoliza <= 1000) {
        this.componentInteractionService.setDeshabilitarComboMedioPagoAportes(
          false
        );
        this.errorAporteCUIMin = true;
        return;
      }

      if (medPag == 'TC' && totalAportePoliza >= 1000001) {
        this.componentInteractionService.setDeshabilitarComboMedioPagoAportes(
          false
        );
        this.errorAporteCUIMax = true;
        return;
      }
    }

    this.abonosPays = [...this.abonosPays, ...aporte];
  }

  onChangeAviso(event) {
    this.showModeResumen = event;
  }

  setDataPagos() {
    this.loading = true;
    const subs = this.productSrv
      .listarLineaNegocio()
      .subscribe(lineasNegocios => {
        if (!lineasNegocios) {
          return;
        }
        this.lineaIndividuales = lineasNegocios.find(
          l => l.LineaNegocio === 'SEGURO INDIVIDUAL'
        );

        const producto = this.lineaIndividuales.ListaProductos.Producto.find(
          p => p.Poliza.toString() === this.idPoliza
        );
        this.codigoRamo = producto.Codigo;
        this.showPeriodicas = this.ruleRamoService.showPeriodica(
          producto.Codigo
        );
        this.showEsporadicas = this.ruleRamoService.showEsporadica(
          producto.Codigo
        );    

        this.showResumen = this.showPeriodicas || this.showEsporadicas;

        this.productSrv.getResumen([this.idPoliza]).subscribe(resumen => {
          this.resumen = resumen;

          //Solo Productos PF
          if (
            this.resumen.CodigoRamo.includes('1200') ||
            this.resumen.CodigoRamo.includes('1300')
          ) {
            this.showModeAviso = false;
            this.showModeResumen = true;
          }
          if (!this.resumen.NombreProducto.includes(this.productAPVSelect))
            return;
          this.showPeriodicas =
            this.resumen.ViaPago === 'DIRECTO' &&
            this.resumen.Periodicidad === 'MENSUAL'
              ? false
              : this.showPeriodicas;
        });

        this.personSrv
          .getPolizaPagosPendientes(producto.Poliza)
          .pipe(
            map(item => {
              return {
                Producto: producto,
                PagosPendientes: item,
              } as IPagosProducto;
            })
          )
          .subscribe(
            data => {
              this.loading = false;
              this.error = false;
              this.data = data;
            },
            err => {
              this.loading = false;
              this.error = true;
            }
          );
      });
    this.subscriptions.push(subs);
  }

}
